import { CIListFilter, DatePicker, getLocaleDateFormat, MultiSelectDropdown } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { FILTER, STATUS_TYPES } from '../../constants';
import { ButtonProp, IQueryParams } from '../../models';
import { AppDispatch } from '../../store/AppStore';
import { convertDateToYYMMDDFormat } from '../../utilities/common/DateUtils';

interface IFilter {
  dispatcherFunction: any;
  reducerFunction: any;
  clearFunction: any;
  filterData: IQueryParams & { pageNo: number } & { item: number } & { searchTitle: string } & { sort: string };
  clearAction: any;
}
export const statusList: string[] = [
  STATUS_TYPES.ACTIVE,
  STATUS_TYPES.INACTIVE,
  STATUS_TYPES.DRAFT,
  STATUS_TYPES.PENDING_APPROVAL,
  STATUS_TYPES.RETURNED
];
const Filter = ({ dispatcherFunction, reducerFunction, filterData, clearFunction, clearAction }: IFilter) => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const statusTypes = [
    { value: STATUS_TYPES.ACTIVE, label: translate('event_filter.txt_active') },
    { value: STATUS_TYPES.INACTIVE, label: translate('event_filter.txt_inactive') },
    { value: STATUS_TYPES.DRAFT, label: translate('event_filter.txt_draft') },
    { value: STATUS_TYPES.READY_FOR_REVIEW, label: translate('event_filter.txt_panding_approval') },
    { value: STATUS_TYPES.RETURNED, label: translate('event_filter.txt_returned') }
  ];

  const [statusMultiFilterValue, setStatusMultiFilterValue] = useState<string[]>(filterData.status ? filterData?.status?.split(',') : []);
  const [selectAllOptions, setSelectAllOptions] = useState<boolean>(false);
  const [searchText, setSearchText] = useState(
    filterData.searchText ? filterData.searchText : ''
  );
  const [toDate, setToDate] = useState<Date | null>(filterData.toDate ? new Date(filterData.toDate) : null);
  const [fromDate, setFromDate] = useState<Date | null>(filterData.fromDate ? new Date(filterData.fromDate) : null);

  const onSubmitApply = () => {
    const queryParam = {
      searchText,
      status: selectAllOptions ? '' : statusMultiFilterValue.toString(),
      toDate: toDate !== null ? `${convertDateToYYMMDDFormat(toDate)}${FILTER.TO_TIMESTAMP_EXTENSION_STR}` : '',
      fromDate: fromDate !== null ? `${convertDateToYYMMDDFormat(fromDate)}${FILTER.FROM_TIMESTAMP_EXTENSION_STR}` : '',
    };
    dispatch(reducerFunction(queryParam));
    dispatch(clearAction(ButtonProp.apply));
  };

  const onClear = () => {
    setSearchText('');
    setToDate(null);
    setFromDate(null);
    setStatusMultiFilterValue([]);
    setSelectAllOptions(false);
    dispatch(dispatcherFunction(0, 10));
    dispatch(clearFunction());
    dispatch(clearAction(ButtonProp.clear));
  };

  const checkApplyStatus = () => {
    const statusFilterValue = statusMultiFilterValue.toString();
    const statusData = filterData.status;
    const toDateData = toDate ? `${convertDateToYYMMDDFormat(toDate)}${FILTER.TO_TIMESTAMP_EXTENSION_STR}` : null;
    const fromDateData = fromDate ? `${convertDateToYYMMDDFormat(fromDate)}${FILTER.FROM_TIMESTAMP_EXTENSION_STR}` : null;
    if (statusFilterValue !== statusData || (toDateData && filterData.toDate !== toDateData) || (fromDateData && filterData.fromDate !== fromDateData)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    setSelectAllOptions((filterData.status === '' || filterData.status === undefined) ? true : filterData?.status?.split(',').length >= 5);
    setStatusMultiFilterValue((filterData.status === '' || filterData.status === undefined) ? statusList : filterData?.status?.split(','));
    setSearchText(filterData.searchText ?? '');
    setFromDate(filterData.fromDate ? new Date(filterData.fromDate) : null);
    setToDate(filterData.toDate ? new Date(filterData.toDate) : null);
  }, [filterData]);

  return (
    <CIListFilter applyEnabled={checkApplyStatus()} onClear={onClear} onApply={onSubmitApply}>
      <Row>
        <Col xs={12} md={6}>
          <DatePicker
            labelText={String(translate('event_filter.txt_last_modified_start'))}
            selected={fromDate}
            onChange={(date: Date | null) => setFromDate(date)}
            maxDate={toDate ?? new Date()}
            placeholderText={String(translate('event_filter.txt_date_range'))}
            dateFormat={getLocaleDateFormat()}
            data-testid="ciListFilterStartDate"
          />
        </Col>
        <Col xs={12} md={6}>
          <DatePicker
            labelText={String(translate('event_filter.txt_last_modified_end'))}
            selected={toDate}
            onChange={(date: Date | null) => setToDate(date)}
            maxDate={new Date()}
            minDate={fromDate ?? undefined}
            placeholderText={String(translate('event_filter.txt_date_range'))}
            dateFormat={getLocaleDateFormat()}
            data-testid="ciListFilterEndDate"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <MultiSelectDropdown
            labelText={String(translate('event_filter.txt_status'))}
            options={statusTypes}
            onSelect={(e: string[]) => setStatusMultiFilterValue(e)}
            handleSelectAll={(e: boolean) => setSelectAllOptions(e)}
            selectAll={selectAllOptions}
            selectedOptions={statusMultiFilterValue}
            height="38px"
            data-testid="ciListStatusSelect"
          />
        </Col>
      </Row>
    </CIListFilter>
  );
};

export default Filter;
